import { siteDetails } from "../siteDetails";

export default function About() {
  return (
    <article id="foretaget" className="invert">
      <section>
        <h2 id="about_title">Om Daniel och företaget</h2>
        <div className={`about-presentation ${siteDetails.portrait ? "with-portrait" : ""}`}>
          {siteDetails.portrait && <img className="portrait" src={siteDetails.portrait} alt="Daniel Haglund" loading="lazy" />}
          <div>
            <p>Jag heter Daniel Haglund och driver Mureri &amp; Eldstäder i Söderhamn AB. Med 24 års erfarenhet av eldstäder, mureri och putsning hjälper jag dig att hitta rätt lösning för ditt projekt.</p>
            <p>Mitt intresse för hantverket väcktes på gymnasiets byggprogram, där jag fastnade för murning och putsning. Sedan dess är det variationen, problemlösningen och glädjen i att skapa något bestående som driver mig.</p>
            <p>För mig börjar ett bra hantverk med att lyssna. Från det första besöket till det färdiga resultatet värdesätter jag en öppen dialog, tydliga besked och att hålla det vi kommit överens om. Du ska känna dig trygg genom hela arbetet.</p>
            <p>Med respekt för hantverkets traditioner och materialens egenskaper arbetar jag för säkra installationer och resultat som håller över tid. Varje projekt får den omsorg det behöver, oavsett om det gäller en eldstad, putsning eller annat mureriarbete.</p>
            <p>Min ambition med företaget är att förena gediget hantverkskunnande med moderna och hållbara lösningar. Målet är att varje kund ska vara riktigt nöjd med resultatet och känna förtroende för att anlita mig igen.</p>
            <p><strong>Tillsammans hittar vi rätt lösning för ditt projekt.</strong></p>
            <a className="cta-link" href="#offert">Kontakta Daniel</a>
          </div>
        </div>
        <div className="company-details">
          <p><strong>Mureri &amp; Eldstäder i Söderhamn AB</strong><br />Org. nr: 559448-8701<br />Grundviksvägen 41<br />826 60 Söderhamn</p>
          <p>Fakturaadress: <a href="mailto:faktura@mureriocheldstader.se">faktura@mureriocheldstader.se</a></p>
        </div>
      </section>
    </article>
  );
}
